const memberWritingNumber = 619;

const MEMBER_WRITING_NUMBER = memberWritingNumber;

export default MEMBER_WRITING_NUMBER;
